import { DOCUMENT } from '@angular/common';
import { APP_INITIALIZER, isDevMode, Provider } from '@angular/core';
import { GOOGLE_ANALYTICS_GTAG_TOKEN, GOOGLE_ANALYTICS_SETTINGS_TOKEN, WINDOW_TOKEN } from '../constants';
import { IGoogleAnalyticsSettings } from '../interfaces/IGoogleAnalyticsSettings';
import { GTagFn } from '../type';


export  const GOOGLE_ANALYTICS_INITIALIZER_PROVIDER: Provider = {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: GoogleAnalyticsInitializer,
    deps: [
        GOOGLE_ANALYTICS_SETTINGS_TOKEN,
        GOOGLE_ANALYTICS_GTAG_TOKEN,
        DOCUMENT,
        WINDOW_TOKEN
    ]
}

export function GoogleAnalyticsInitializer(
    settings: IGoogleAnalyticsSettings,
    gtagFn: GTagFn,
    document: Document,
    window: Window
){
    return async () => {
        if(!settings.trackingCode){
            console.warn("[GoogleAnalytics] - no tracking code. Check the settings of module GoogleAnalytics. Library not loaded.");
            return;
        }
        if(!gtagFn && !isDevMode()){
            throw new Error("[Google ANalytics] - not possible to create GtagFn. Make sure this module is running on a Browser.")
        }
        if(!document && !isDevMode()){
            throw new Error("[Google ANalytics] - not possible to access of document interface. Make sure this module is running on a Browser.")
        }

        settings.url = settings.url || `https://www.googletagmanager.com/gtag/js?id=${settings.trackingCode}`;

        // initialisation commands
        gtagFn("js", new Date());
        gtagFn("config", settings.trackingCode);

        // anonimizeIp
        if(settings.anonymizeIp) gtagFn("config", settings.trackingCode, { 'anonymize_ip': settings.anonymizeIp })

        // désactivation de google analytics
        if(!settings.enableTracing && window){
            window[`ga-disable-${settings.trackingCode}`] = true;
        }

        // import library
        var script = document.createElement("script");
        script.async = true;
        script.src = settings.url;
        document.head.appendChild(script);
    }
}